import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
import { FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { BoldLittleText, LightText, LittleText, Subtitle } from "./HXMobilePage.styles";
import { withLoadTracking } from "./withLoadTracking";
import { HXAccordion } from "./HXAccordion";
export const RequestDetailsParent = styled.div `
    padding: 0;
    align-self: stretch;
    display: flex;
    flex-direction: column;
    gap: 0;
`;
export const Accordion = styled(HXAccordion) `
    background-color: ${colors.white_background};
    border: 1px solid ${colors.blue_10};
    border-radius: 12px !important;
    margin-bottom: 12px;

    // Remove default divider from HXAccordion
    &::before,
    &.Mui-expanded::before,
    &.Mui-expanded::before,
    &.Mui-expanded + &&.Mui-expanded::before {
        display: none;
    }

    // Last item shouldn't have margin
    &:last-of-type {
        margin-bottom: 0;
    }

    // Hide extra space between elements when expanded
    &.Mui-expanded {
        margin-bottom: 12px;
    }

    // Override HXAccordion styles for request details
    & .MuiAccordionSummary-root {
        min-height: 48px;
        padding: 12px;
        height: auto;

        &.Mui-expanded {
            min-height: 48px;
            border-bottom: 1px solid ${colors.blue_10};
        }
    }

    & .MuiAccordionSummary-content {
        font-weight: ${fontWeights.NORMAL};
        font-size: ${fontSizes.LITTLE};
        line-height: normal;
    }

    & .MuiAccordionDetails-root {
        padding: 12px;
        color: ${colors.black_lighter};
    }
`;
export const DetailsContainer = styled(FlexColumnDiv) `
    gap: 12px;
`;
export const OrganizationsContainer = styled(FlexColumnDiv) `
    gap: 8px;
    padding: 0 12px;
`;
export const MultilineText = styled.div `
    white-space: pre-wrap;
    color: ${colors.black_lighter};
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
`;
export const BoldInlineMultilineText = styled(MultilineText) `
    display: inline;
    font-weight: ${fontWeights.BOLD};
`;
export const OrganizationContainer = styled(FlexRowDiv) `
    gap: 16px;
    padding: 0 12px;
    align-items: center;
`;
export const OrganizationImage = styled.img `
    display: block;
    object-fit: contain;
    width: 36px;
    height: 36px;
    flex-shrink: 0;
`;
export const OrganizationImageWithLoadTracking = withLoadTracking(OrganizationImage);
export const DetailsLabel = styled(Subtitle) ``;
export const DetailsValue = styled(LightText) `
    margin-bottom: 16px;
`;
export const ParagraphContainer = styled(FlexColumnDiv) `
    gap: 8px;
`;
export const FrequencyContainer = styled(FlexColumnDiv) `
    gap: 12px;
`;
export const QuestionsContainer = styled(FlexColumnDiv) `
    gap: 12px;
`;
export const ContactContainer = styled(FlexColumnDiv) `
    gap: 4px;
`;
export const IconTextRow = styled(FlexRowDiv) `
    gap: 8px;
    align-items: center;
`;
export const EmailIcon = styled.img `
    width: 16px;
    height: 16px;
    object-fit: contain;
`;
export const PhoneIcon = styled.img `
    width: 16px;
    height: 16px;
    object-fit: contain;
`;
export const DetailsIcon = styled.img `
    width: 16px;
    height: 16px;
    object-fit: contain;
`;
export const CalendarRepeatIconImg = styled.img `
    width: 20px;
    height: 20px;
    object-fit: contain;
`;
export const PersonIconContainer = styled.div `
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: ${colors.blue_10};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    opacity: 0.7;
`;
export const PersonIconImg = styled.img `
    width: 20px;
    height: 20px;
    opacity: 1;
    object-fit: contain;
`;
export const HealthExIconContainer = styled.div `
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;
export const HealthExIconImg = styled.img `
    width: 28px;
    height: 28px;
    opacity: 1;
    object-fit: contain;
`;
export const ResquestDetailsContactName = styled(BoldLittleText) `
    color: ${colors.black_lighter};
`;
export const ResquestDetailsContactTitle = styled(LittleText) `
    color: ${colors.black_lighter};
`;
